module.exports = __webpack_public_path__ + "img/uploadfiledemo.8f41660b.png";